import State from '../core/State';
import initialState from '../initialState';
import Work from '../entity/Work';

export const startFetchingWorks = () => (state: State): State => ({
  ...state,
  works: {
    ...state.works,
    fetching: state.works.fetching + 1,
  },
});

export const finishFetchingWorks = () => (state: State): State => ({
  ...state,
  works: {
    ...state.works,
    fetching: state.works.fetching - 1,
  },
});

export const setWorks = (works: Work[], nextCursor: string | null) => (state: State): State => ({
  ...state,
  works: {
    ...state.works,
    items: works,
    nextCursor,
  },
});

export const appendWorks = (works: Work[], nextCursor: string | null) => (state: State): State => ({
  ...state,
  works: {
    ...state.works,
    items: state.works.items.concat(works),
    nextCursor,
  },
});

export const disposeWorks = () => (state: State): State => ({
  ...state,
  works: initialState.works,
});
